import { useRecordContext } from 'react-admin';
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import {
  loadingAlertHint,
  loadingAlertOf,
  loadingAlertTitle,
  SALE_RECOMMENDATION_LABEL,
  saleRecommendationOf,
} from './markers';
import { useFeature } from '../featureFlags/FeatureGate';
import { FEATURE_SALE_RECOMMENDATION } from './listFeatures';

/**
 * Znaczniki z odpowiedzi Marathonu 07.10.2026 na karcie zlecenia:
 *
 * - „Jutro załadunek, bez auta” — alert z przeglądu o 15:00 w dniu
 *   poprzedzającym załadunek (`loadingAlert` z API, reguła
 *   `apps/api/src/user-offers/loading-alert.ts`), dopóki zlecenie nie ma
 *   wykonawcy;
 * - „Rekomendowane do sprzedaży” — zlecenia STANDARD i MEGA w planowaniu
 *   FTL (`saleRecommendation`, reguła `sale-recommendation.ts`).
 *
 * Oba tylko informują: obsadza i przekazuje do Trade człowiek. Brak obu —
 * nic nie pokazujemy.
 */
export const OrderMarkerAlerts = () => {
  const record = useRecordContext() as Record<string, unknown> | undefined;
  // „Do sprzedaży” tylko z przełącznikiem (decyzja użytkownika 12.10.2026);
  // bez niego karta jak na produkcji 0.31.3.
  const saleOn = useFeature(FEATURE_SALE_RECOMMENDATION);
  if (!record) return null;
  const loading = loadingAlertOf(record);
  const sale = saleOn ? saleRecommendationOf(record) : null;
  if (!loading && !sale) return null;
  return (
    <Stack spacing={1}>
      {loading ? (
        <Alert severity={loading.when === 'today' ? 'error' : 'warning'}>
          <AlertTitle>{loadingAlertTitle(loading)}</AlertTitle>
          <Typography variant="body2">{loadingAlertHint(loading)}</Typography>
        </Alert>
      ) : null}
      {sale ? (
        <Alert severity="info">
          <AlertTitle>{SALE_RECOMMENDATION_LABEL}</AlertTitle>
          <Typography variant="body2">{sale.text}</Typography>
        </Alert>
      ) : null}
    </Stack>
  );
};
